<h2 mat-dialog-title>
  <mat-icon class="title-icon">account_tree</mat-icon>
  {{ (data.node ? 'WORKCLASSIFICATION.TEMPLATES.NODE.TITLE_EDIT' : 'WORKCLASSIFICATION.TEMPLATES.NODE.TITLE_ADD') | translate }}
</h2>
<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="dialog-container">
    <div class="app-container">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.NAME' | translate }}</mat-label>
        <input matInput formControlName="name" maxlength="200" required />
        @if (form.controls.name.hasError('required')) {
          <mat-error>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.REQUIRED' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.FORM.DESCRIPTION' | translate }}</mat-label>
        <textarea matInput formControlName="description" rows="3"></textarea>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.NODE.PARENT' | translate }}</mat-label>
        <mat-select formControlName="parentId">
          <mat-option [value]="null">{{ 'WORKCLASSIFICATION.TEMPLATES.NODE.ROOT' | translate }}</mat-option>
          @for (p of parents; track p.node.id) {
            <mat-option [value]="p.node.id">
              <span [style.padding-left.rem]="p.depth">{{ p.node.name }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-raised-button type="submit" class="btn-primary" [disabled]="saving()">{{ 'COMMON.SAVE' | translate }}</button>
  </mat-dialog-actions>
</form>
